import {
  BasicButton,
  ButtonGroup,
  LegacyModal,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalTrigger,
  PrimaryButton,
  Text,
} from "@certn/cascadia-react";
import { weights } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";
import React from "react";
import { Trans, useTranslation } from "react-i18next";

import { useCountryName } from "../../../../components/AddressInput";

type MissingCountriesModalProps = {
  trigger: JSX.Element;
  missingCountries: string[];
  onContinue: () => void;
};

export function MissingCountriesModal({
  trigger,
  missingCountries,
  onContinue,
}: MissingCountriesModalProps) {
  const { t } = useTranslation();
  const getCountryName = useCountryName();

  let text1 = t("the following country");
  let text2 = t("this country");
  if (missingCountries.length > 1) {
    text1 = t("the following countries");
    text2 = t("these countries");
  }

  return (
    <ModalTrigger trigger={() => trigger}>
      {(close) => (
        <LegacyModal width="456px">
          <ModalHeader
            close={close}
            title={t("Address history is incomplete")}
          />

          <ModalContent>
            <Text style="global/body-primary">
              <Trans>
                This application recommends a minimum of 1 address from {text1}:
              </Trans>
            </Text>{" "}
            {missingCountries.map((country, i) => (
              <React.Fragment key={i}>
                <Text
                  style="global/body-primary"
                  className={css({ fontWeight: weights["font-weight-medium"] })}
                >
                  {getCountryName(country)}
                </Text>
                {i !== missingCountries.length - 1 && <>, </>}
              </React.Fragment>
            ))}
            <br />
            <br />
            <Text style="global/body-primary">
              <Trans>
                If you do not have an address from {text2} or you would like to
                skip this step, please select 'Continue'.
              </Trans>
            </Text>
          </ModalContent>

          <ModalFooter>
            <ButtonGroup>
              <BasicButton size="medium" onPress={close}>
                <Trans>Cancel</Trans>
              </BasicButton>
              <PrimaryButton
                type="submit"
                size="medium"
                onPress={() => {
                  close();
                  onContinue();
                }}
              >
                <Trans>Continue</Trans>
              </PrimaryButton>
            </ButtonGroup>
          </ModalFooter>
        </LegacyModal>
      )}
    </ModalTrigger>
  );
}
